export const aboutData = {
  // HackDFW is
  taglines: [
    "a celebration of Dallas' entreprenurial spirit.",
    "the Design Thinking Hackathon of Texas.",
    "the new career fair.",
    "your connection to tech in Dallas-Fort Worth.",
  ]
}
